import type { ReactNode } from 'react';

/**
 * Accessible name for a status badge repeated in every table row, e.g. "Download: Yes, PG&E Electric",
 * so the badges stay distinguishable in a screen reader's list of buttons. A badge showing only "-" keeps
 * the dash and adds its card title when that title is plain text, since a dash alone reads as nothing.
 */
export function rowBadgeLabel(column: string, status: string, row: string, cardTitle?: ReactNode): string {
  const spoken = status.trim() === '-' && typeof cardTitle === 'string' ? `${status}, ${cardTitle}` : status;
  return `${column}: ${spoken}, ${row}`;
}
